<div *ngIf="supplier" class="card mt-2">
    <div class="card-body card-suivi-achats">
        <form id="frmSuiviAchats" name="frmSuiviAchats" #frmSuiviAchats="ngForm">
            <div class="row">
                <div class="col">
                    <div class="card">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-3">
                                    <label class="control-label">Accord cadre</label>
                                </div>  
                                <div class="col-9">
                                    {{AccordCadreVal}}
                                </div>
                            </div>
                            <hr/>
                            <div class="row">
                                <div class="col-3">
                                    <label class="control-label">Groupement</label>
                                </div>  
                                <div class="col-9">
                                    <switchery-ios [disabled]="!canUpdateSuiviAchatsPanneauGauche || !editMode"
                                            [(ngModel)]="suiviAchatsDatas.TopGroupement" size="medium" name="Groupement"></switchery-ios>
                                </div>

                            </div>
                            <hr/>
                            <div class="row">
                                <div class="col-3 d-flex align-items-center">
                                    <label class="control-label">Panel régional</label>
                                </div>
                                <div class="col-9">                            
                                    <table class="table table-sm table-hover" style="width:100%;">
                                        <thead *ngIf="canUpdateSuiviAchatsPanneauGauche">
                                            <tr>
                                                <td class="d-flex">
                                                    <div class="flex-fill">
                                                        <kendo-combobox name="selectedPerimeter" [data]="unselectedPerimeters"
                                                            [disabled]="!editMode" [textField]="'EtbLib'" [valueField]="'EtbXRP'"
                                                            [(ngModel)]="selectedPerimeter" style="width: 100%;">
                                                            <ng-template kendoComboBoxItemTemplate let-dataItem>
                                                                <div class="kendo-dropdown-item">{{dataItem.EtbLib}}</div>
                                                            </ng-template>
                                                        </kendo-combobox>
                                                    </div>
                                                    <button *ngIf="editMode && unselectedPerimeters.length>0" class="btn btn-xs btn-warning ml-1" btnDebounceClick data-toggle="tooltip" data-placement="top" title="Ajouter tout"
                                                        (debounceClick)="addAllPerimeters()">
                                                        <i class="fas fa-caret-square-down"></i>
                                                    </button>
                                                    <button *ngIf="editMode && suiviAchatsDatas.DivSAPs.length>0" class="btn btn-xs btn-danger ml-1" btnDebounceClick data-toggle="tooltip" data-placement="top" title="Supprimer tout"
                                                        (debounceClick)="deleteAllPerimeters()">
                                                        <i class="fas fa-times-circle"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let line of selectedPerimeters">
                                                <td class="d-flex">
                                                    <div class="flex-grow-1">{{line.EtbLib}}</div>
                                                    <button class="btn btn-xs btn-danger ml-1" btnDebounceClick
                                                        (debounceClick)="removePerimeter(line)"
                                                        *ngIf="canUpdateSuiviAchatsPanneauGauche && editMode">
                                                        <i class="fas fa-trash-alt"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>                                
                                </div>
                            </div>
                        </div>
                    </div>
                    <pre *ngIf="sharedDataSvc.debug">suiviAchatsDatas = {{suiviAchatsDatas | json}}</pre>
                </div>
                <div class="col-9" *ngIf="canViewFilesAndComments">
                    <div *ngIf="canViewContratCadre">
                        <div class="row">
                            <div class="col-4">
                                <label class="control-label">Contrat cadre</label>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-4">
                                        <kendo-combobox name="codDocContratCadreSel" [data]="lstContratsCadreForCods"
                                            [textField]="'LibDoc'" [valueField]="'RefDocId'"
                                            [(ngModel)]="suiviAchatsDatas.FrameworkContractPafDocId"
                                            [valuePrimitive]="true" style="width:100%;"
                                            (valueChange)="ContratsCadreTypeChange($event)"
                                            [disabled]="!canUpdateContratCadre" class="mx-l">
                                        </kendo-combobox>
                                    </div>
                                    <div class="col-8 d-flex align-items-center justify-content-start">
                                        <div class="mr-1 mt-1 text-primary"
                                            paftooltip="La_date_doit_etre_superieure_a_la_date_du_jour">
                                            <i class="fas fa-info-circle"></i>
                                        </div>
                                        <div class="mt-1 mx-1" paflabel="Date_echeance"></div>
                                        <div class="flex-shrink-0 px-1" style="width:145px;">
                                            <kendo-datepicker class="form-control" allowInput="true"
                                                name="FrameworkContractDate"
                                                style="width:100%;" [(ngModel)]="suiviAchatsDatas.FrameworkContractDate"
                                                [required]="!!suiviAchatsDatas.FrameworkContractPafDocId"
                                                [disabled]="!canUpdateContratCadre">
                                            </kendo-datepicker>
                                        </div>
                                        <div class="flex-fill">
                                            <doc-histo-button class="float-right" [supplier]="supplier"></doc-histo-button>
                                        </div>
                                    </div>
                                </div>
                                <div *ngFor="let docCom of lstContratsCadre | orderBy :'sortOrder' : true; let i = index">
                                    <pilotage-doc-commercial 
                                        [(ngModel)]="lstContratsCadre[i]"
                                        (docChanged)="onDocComChanged($event)" 
                                        name="docCommercial{{i}}"
                                        [readonly]="!canAddDocCommercial" 
                                        [required]="!!suiviAchatsDatas.FrameworkContractPafDocId && lstContratsCadre.length==1">
                                    </pilotage-doc-commercial>
                                </div>
                                <input type="hidden" name="FrameworkContractPafDocIdHidden" value="" [required]="contratCadreRequired" />
                            </div>
                        </div>
                    </div>


                    <div class="row">
                        <div class="col-4">
                            <label class="control-label">Documents commerciaux</label>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-body">
                            <div *ngFor="let docCom of lstDocsCom | orderBy :'sortOrder' : true; let i = index">
                                <pilotage-doc-commercial name="lstDocsCom{{i}}" [(ngModel)]="lstDocsCom[i]" (docChanged)="onDocComChanged($event)"
                                    [readonly]="!canAddDocCommercial">
                                </pilotage-doc-commercial>
                            </div>
                            <!-- <pre *ngIf="sharedDataSvc.debug">{{lstDocsCom | json}}</pre> -->
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-4">
                            <label class="control-label">Commentaires achats</label>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-body">
                            <div *ngFor="let pc of supplier.SupplierPurchaseComments" class="mb-1">
                                <commentaire-achats [commentaire]="pc" [readonly]="!canAddDocCommentaire"
                                    (addComment)="onAddComment($event)" (delComment)="onDelComment($event)">
                                </commentaire-achats>
                            </div>
                            <div *ngIf="canAddDocCommentaire">
                                <commentaire-achats [commentaire]="emptyComment" [readonly]="false"
                                    (addComment)="onAddComment($event)" (delComment)="onDelComment($event)">
                                </commentaire-achats>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </form>
    </div>
    <div *ngIf="showEditButton" class="card-footer">
        <div class="d-flex justify-content-center">
            <button *ngIf="!editMode" type="button" class="btn btn-sm btn-primary" btnDebounceClick
                (debounceClick)="btnEditModifAchatsClick()">Modifier</button>
            <button *ngIf="editMode" type="button" class="btn btn-sm btn-warning" btnDebounceClick
                (debounceClick)="btnAnnuleModifAchatsClick()">Annuler</button>
            <button *ngIf="editMode" type="button" class="btn btn-sm btn-success ml-2" btnDebounceClick
                (debounceClick)="btnValidModifAchatsClick(frmSuiviAchats)">Valider</button>
        </div>
    </div>
</div>